import { Injectable } from '@angular/core';

import { Action, Selector, State, StateContext } from '@ngxs/store';

import { AppVariants, GenericStateModel } from '@store/models/generic.model';
import { SetAppVariant } from '@store/actions/generic.actions';
import { environment } from '@environments/environment';

@State<GenericStateModel>({
  name: 'generic',
  defaults: {
    variant: environment.variant?.toUpperCase() as AppVariants || 'DOE',
  },
})
@Injectable()
export class GenericState {
  @Action(SetAppVariant)
  setAppVariant(ctx: StateContext<GenericStateModel>, action: SetAppVariant) {
    ctx.patchState({ variant: action.variant });
  }

  @Selector()
  static getVariant(state: GenericStateModel): AppVariants | null {
    return state.variant;
  }
}
